module.exports = __webpack_public_path__ + "images/52c235cfc21b037c320712891df2cffc.svg";